import {
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  ArrowLeftRight,
  Award,
  Banknote,
  Barcode,
  Bot,
  Calculator,
  CheckCircle2,
  CheckSquare,
  ClipboardCheck,
  Coins,
  Compass,
  Copy,
  Cpu,
  Factory,
  FileCheck,
  FileCode,
  FileDiff,
  FileStack,
  Flame,
  FolderCheck,
  FolderTree,
  GitMerge,
  GitPullRequest,
  GraduationCap,
  Headphones,
  Heart,
  Hourglass,
  type LucideIcon,
  Megaphone,
  MessageCircle,
  MessagesSquare,
  Navigation,
  Percent,
  Phone,
  PhoneCall,
  Plug,
  QrCode,
  ReceiptText,
  Repeat,
  Scale,
  ShieldAlert,
  Smile,
  Split,
  Tag,
  Tags,
  Target,
  Timer,
  TrendingDown,
  Truck,
  UserMinus,
  UserPlus,
} from 'lucide-react';

export const domainIcons: Record<string, LucideIcon> = {
  // Domain Specific & Module Icons
  'alert-circle': AlertCircle,
  'alert-octagon': AlertOctagon,
  'alert-triangle': AlertTriangle,
  'arrow-left-right': ArrowLeftRight,
  award: Award,
  banknote: Banknote,
  barcode: Barcode,
  bot: Bot,
  calculator: Calculator,
  'check-circle-2': CheckCircle2,
  'check-square': CheckSquare,
  'clipboard-check': ClipboardCheck,
  coins: Coins,
  compass: Compass,
  copy: Copy,
  cpu: Cpu,
  factory: Factory,
  'file-check': FileCheck,
  'file-code': FileCode,
  'file-diff': FileDiff,
  'file-stack': FileStack,
  flame: Flame,
  'folder-check': FolderCheck,
  'folder-tree': FolderTree,
  'git-merge': GitMerge,
  'git-pull-request': GitPullRequest,
  'graduation-cap': GraduationCap,
  headphones: Headphones,
  heart: Heart,
  hourglass: Hourglass,
  megaphone: Megaphone,
  'message-circle': MessageCircle,
  'messages-square': MessagesSquare,
  navigation: Navigation,
  percent: Percent,
  phone: Phone,
  'phone-call': PhoneCall,
  plug: Plug,
  'qr-code': QrCode,
  'receipt-text': ReceiptText,
  repeat: Repeat,
  scale: Scale,
  'shield-alert': ShieldAlert,
  smile: Smile,
  split: Split,
  tag: Tag,
  tags: Tags,
  target: Target,
  timer: Timer,
  'trending-down': TrendingDown,
  truck: Truck,
  'user-minus': UserMinus,
  'user-plus': UserPlus,
};
